var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOriginalBgImg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 169 509.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: url(#linear-gradient-2);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke: url(#linear-gradient-3);\n      }\n\n      .cls-3 {\n        stroke: url(#linear-gradient-9);\n      }\n\n      .cls-4 {\n        stroke: url(#linear-gradient-4);\n      }\n\n      .cls-5 {\n        stroke: url(#linear-gradient-6);\n      }\n\n      .cls-6 {\n        opacity: .8;\n      }\n\n      .cls-7 {\n        stroke: url(#linear-gradient-13);\n      }\n\n      .cls-8 {\n        stroke: url(#linear-gradient-7);\n      }\n\n      .cls-9 {\n        stroke: url(#linear-gradient-12);\n      }\n\n      .cls-10 {\n        stroke: url(#linear-gradient-5);\n      }\n\n      .cls-11 {\n        stroke: url(#linear-gradient);\n      }\n\n      .cls-12 {\n        stroke: url(#linear-gradient-14);\n      }\n\n      .cls-13 {\n        stroke: url(#linear-gradient-11);\n      }\n\n      .cls-14 {\n        stroke: url(#linear-gradient-8);\n      }\n\n      .cls-15 {\n        stroke: url(#linear-gradient-10);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 310.52,
    y1: -20.5,
    x2: 310.52,
    y2: 497.71,
    gradientTransform: "translate(-276.75 69.73) rotate(-9.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#f8eb30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#28a8e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65308f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 370.85,
    y1: -169.08,
    x2: 370.85,
    y2: 350.03,
    gradientTransform: "translate(-305.77 210.08) rotate(-6.59) scale(.99)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 418.83,
    y1: -325.79,
    x2: 418.83,
    y2: 193.59,
    gradientTransform: "translate(-334.79 350.43) rotate(-4) scale(.98)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 453.03,
    y1: -489.06,
    x2: 453.03,
    y2: 29.88,
    gradientTransform: "translate(-363.81 490.78) rotate(-1.37) scale(.97)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 472.23,
    y1: -657.06,
    x2: 472.23,
    y2: -139.28,
    gradientTransform: "translate(-392.83 631.12) rotate(1.31) scale(.96)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 475.84,
    y1: -827.7,
    x2: 475.84,
    y2: -311.81,
    gradientTransform: "translate(-421.85 771.47) rotate(4.02) scale(.96)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 465.57,
    y1: -998.71,
    x2: 465.57,
    y2: -485.45,
    gradientTransform: "translate(-450.87 911.82) rotate(6.75) scale(.96)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 438.72,
    y1: -1167.76,
    x2: 438.72,
    y2: -657.85,
    gradientTransform: "translate(-479.88 1052.17) rotate(9.48) scale(.96)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 395.66,
    y1: -1332.56,
    x2: 395.66,
    y2: -826.65,
    gradientTransform: "translate(-508.9 1192.52) rotate(12.21) scale(.96)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 337.19,
    y1: -1490.94,
    x2: 337.19,
    y2: -989.64,
    gradientTransform: "translate(-537.92 1332.87) rotate(14.92) scale(.96)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 264.5,
    y1: -1640.97,
    x2: 264.5,
    y2: -1144.79,
    gradientTransform: "translate(-566.94 1473.21) rotate(17.6) scale(.97)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 177.84,
    y1: -1781.01,
    x2: 177.84,
    y2: -1290.39,
    gradientTransform: "translate(-595.96 1613.56) rotate(20.24) scale(.98)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 80.36,
    y1: -1909.78,
    x2: 80.36,
    y2: -1425.07,
    gradientTransform: "translate(-624.98 1753.91) rotate(22.83) scale(.99)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -25.95,
    y1: -2026.38,
    x2: -25.95,
    y2: -1547.82,
    gradientTransform: "translate(-654 1894.26) rotate(25.35)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m28.11.44c5.88,3.3,49.01,21.36,57.01,77.17,8.83,61.64-1.15,63.46-23.82,149.62-22.76,86.53-27.94,136.41-12.28,187.83,5.23,17.15,21.82,61.7,75.37,93.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m37.09,2.78c5.72,3.62,47.89,24.12,54.13,79.48,6.89,61.14-3.04,62.3-28.06,145.53-25.13,83.59-31.75,132.29-17.78,183.82,4.66,17.19,19.76,62.03,71.81,97.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m46.07,5.12c5.56,3.94,46.77,26.88,51.26,81.79,4.96,60.65-4.93,61.13-32.31,141.44-27.5,80.65-35.57,128.16-23.29,179.8,4.1,17.23,17.7,62.36,68.26,100.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m55.04,7.46c5.41,4.25,45.65,29.63,48.39,84.09,3.03,60.15-6.82,59.97-36.56,137.35-29.86,77.71-39.38,124.03-28.79,175.79,3.53,17.27,15.63,62.69,64.7,103.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m64.02,9.8c5.25,4.57,44.53,32.39,45.52,86.4,1.1,59.65-8.71,58.8-40.8,133.25-32.23,74.77-43.19,119.9-34.3,171.78,2.97,17.31,13.57,63.01,61.15,106.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m73,12.14c5.09,4.89,43.41,35.15,42.65,88.71-.84,59.15-10.6,57.64-45.05,129.16-34.6,71.83-47,115.77-39.8,167.76,2.4,17.34,11.51,63.34,57.59,109.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m81.98,14.47c4.94,5.21,42.29,37.91,39.78,91.01-2.77,58.66-12.49,56.47-49.3,125.07-36.97,68.89-50.81,111.64-45.3,163.75,1.84,17.38,9.45,63.67,54.04,113.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m90.95,16.81c4.78,5.53,41.17,40.66,36.91,93.32-4.7,58.16-14.38,55.31-53.55,120.98-39.34,65.95-54.62,107.52-50.81,159.74,1.27,17.42,7.39,64,50.49,116.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m99.93,19.15c4.62,5.84,40.05,43.42,34.04,95.63-6.63,57.66-16.27,54.14-57.79,116.89-41.7,63.01-58.43,103.39-56.31,155.72.71,17.46,5.32,64.33,46.93,119.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m108.91,21.49c4.47,6.16,38.93,46.18,31.17,97.94-8.57,57.16-18.16,52.98-62.04,112.79-44.07,60.07-62.24,99.26-61.82,151.71.14,17.5,3.26,64.66,43.38,122.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m117.89,23.83c4.31,6.48,37.81,48.94,28.3,100.24-10.5,56.67-20.05,51.81-66.29,108.7-46.44,57.13-66.05,95.13-67.32,147.69-.42,17.53,1.2,64.99,39.82,125.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m126.86,26.17c4.15,6.8,36.69,51.69,25.43,102.55-12.43,56.17-21.93,50.65-70.53,104.61-48.81,54.19-69.86,91-72.83,143.68-.99,17.57-.86,65.32,36.27,129.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m135.84,28.51c4,7.11,35.56,54.45,22.56,104.86-14.36,55.67-23.82,49.48-74.78,100.52C32.44,285.14,9.94,320.76,5.29,373.55c-1.55,17.61-2.92,65.65,32.72,132.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m144.82,30.85c3.84,7.43,34.44,57.21,19.69,107.16-16.3,55.17-25.71,48.32-79.03,96.42C31.93,282.76,7.99,317.19,1.64,370.1c-2.12,17.65-4.98,65.98,29.16,135.43"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOriginalBgImg2);
export default __webpack_public_path__ + "static/media/original-bg-img-2.99d3c2f5a2e3c38667cf9bb50f322880.svg";
export { ForwardRef as ReactComponent };